import React, { useEffect } from "react";
import { Button, Checkbox, Input, Label, Select } from "uxp/components";
import { IContextProvider } from "../../uxp";
import { IWDDesignModeProps } from "./common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { generateUUID, hasValue, tryParseJSON } from "../../util";
import EditorComponent from "./EditorComponent";

export interface IParam {
    id: string,
    name: string,
    type: 'text' | 'string' | 'number' | 'boolean' | 'json',
    defaultValue: any
}

interface IWidgetParamsEditorProps {
    uxpContext: IContextProvider
    designer: IWDDesignModeProps
    params: IParam[]
    onChange: (newParams: IParam[]) => void
}

export const WidgetParamsEditor: React.FunctionComponent<IWidgetParamsEditorProps> = (props) => {

    const { uxpContext, designer, params, onChange } = props


    function addNew() {
        const _params = [...params]

        _params.push({
            id: generateUUID(),
            name: '',
            type: 'string',
            defaultValue: ''
        })

        onChange(_params)
    }


    function updateProps(id: string, key: string, value: any) {
        const _params = [...params]
        const updated = _params.map(t => {
            if (t.id == id) {
                (t as any)[key] = value
            }
            return t
        })
        onChange(updated)
    }



    function renderValueEditor(p: IParam) {
        if (p.type == 'boolean') {
            return <Checkbox
                checked={p.defaultValue || false}
                onChange={v => updateProps(p.id, 'defaultValue', v)}
                className="widget-designer-input"
                label="Default value"
            />
        }
        else if (p.type == 'json') {
            return <Input
                value={p.defaultValue}
                onChange={v => updateProps(p.id, 'defaultValue', v)}
                className="widget-designer-input"
            />
        }
        else if (p.type == 'number') {
            return <Input
                type='number'
                value={p?.defaultValue?.toString()}
                onChange={v => {
                    let num = Number(v)
                    if (isNaN(num) || !isFinite(num)) num = 0
                    updateProps(p.id, 'defaultValue', num)
                }}
                className="widget-designer-input"
            />
        }
        return <Input
            value={p.defaultValue}
            onChange={v => updateProps(p.id, 'defaultValue', v)}
            className="widget-designer-input"
        />
    }

    return <div className="wd-mobile-navigation-tabs-config-container">
        <React.Fragment>
            {params?.map((p, i) => (<div className="wd-mobile-navigation-tabs-config-tab">
                <div className="wd-mobile-navigation-tabs-config-tab-remover"
                    onClick={() => {
                        const _params = [...params].filter(_p => _p.id !== p.id)
                        onChange(_params)
                    }}
                >
                    <FontAwesomeIcon icon={['fas', 'times']} />
                </div>
                <div className="wd-mobile-navigation-tabs-config-content">
                    <div className="section">
                        <Label>Name</Label>
                        <Input
                            value={p.name}
                            onChange={v => {
                                updateProps(p.id, 'name', v)
                            }}
                            className="widget-designer-input"
                        />
                    </div>

                    <div className="section">
                        <Label>Type</Label>
                        <Select
                            selected={hasValue(p?.type) ? p.type == 'text' ? 'string' : p.type : ''}
                            onChange={(v, o) => {
                                updateProps(p.id, 'type', v)
                            }}
                            options={[
                                { label: 'Text', value: 'string' },
                                { label: 'Number', value: 'number' },
                                { label: 'Boolean', value: 'boolean' },
                                // { label: 'Json', value: 'json' },
                            ]}
                            className="widget-designer-input"
                        />
                    </div>

                    <div className="section">
                        <Label>DefaultValue</Label>

                        {renderValueEditor(p)}
                    </div>
                </div>

            </div>))}
        </React.Fragment>
        <div className="wd-mobile-navigation-tabs-config-tab">
            <Button
                className="new-option"
                title="Add Param"
                icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
                iconPosition="right"
                onClick={addNew}
                active
            />
        </div>
    </div>

}